"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payment = void 0;
const endpoint_1 = require("../endpoint/endpoint");
const utils_1 = require("../utils");
const base = '/payment';
const requestSwishPayment = (payload, options) => {
    const url = (0, utils_1.urlFactory)(base, '/request-swish-payment');
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'POST' },
        payload,
        options
    });
};
const byOrderId = (payload, options) => {
    const url = (0, utils_1.urlFactory)(base, '/by-order-id');
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'POST' },
        options,
        payload
    });
};
const paymentRequestStatus = (payload, options) => {
    const url = (0, utils_1.urlFactory)(base, '/payment-request-status');
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'POST' },
        options,
        payload
    });
};
exports.payment = { requestSwishPayment, byOrderId, paymentRequestStatus };
